module.exports = __webpack_public_path__ + "static/media/login_mini.b43cc05f.jpg";